var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "management-section-wrapper" },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "management-section-title" }, [
                _vm._v(_vm._s(_vm.$tc("Role", 2)))
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.canSeeTable
                ? _c("v-text-field", {
                    staticClass: "data-table-search",
                    attrs: {
                      value: _vm.searchFromParent,
                      "append-icon": "search",
                      label: _vm.$t("Search"),
                      placeholder: _vm.$t("Search"),
                      "single-line": "",
                      "hide-details": ""
                    },
                    on: { input: _vm.updateSearchInParent }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.canSeeTable
            ? _c("v-data-table", {
                class: {
                  "no-show-permission": !_vm.userHasPermissionTo("show")
                },
                attrs: {
                  headers: _vm.headers,
                  items: _vm.roles,
                  search: _vm.searchFromParent,
                  loading: _vm.loading,
                  "loading-text": "",
                  page: _vm.pagination.page,
                  "items-per-page": _vm.paginationRole.rowsPerPage,
                  "items-per-page-text": _vm.rowsPerPageText,
                  "items-per-page-items": _vm.rowsPerPageItems,
                  "header-props": { sortIcon: _vm.sortIcon },
                  "footer-props": {
                    prevIcon: _vm.prevIcon,
                    nextIcon: _vm.nextIcon,
                    "items-per-page-options": _vm.rowsPerPageItems
                  }
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.pagination, "page", $event)
                  },
                  "update:itemsPerPage": function($event) {
                    return _vm.$set(_vm.paginationRole, "rowsPerPage", $event)
                  },
                  "update:items-per-page": function($event) {
                    return _vm.$set(_vm.paginationRole, "rowsPerPage", $event)
                  },
                  pagination: function($event) {
                    return _vm.setRowsOnLocalStorage(
                      _vm.dataTableRoleListId,
                      _vm.paginationRole.rowsPerPage
                    )
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item",
                      fn: function(props) {
                        return [
                          _c(
                            "tr",
                            {
                              class: {
                                "cursor-pointer": _vm.userHasPermissionTo(
                                  "show"
                                )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.viewItem(props.item)
                                }
                              }
                            },
                            [
                              _c("td", [_vm._v(_vm._s(props.item.label))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(props.item.description))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("div", {
                                  staticClass: "user-status-icon",
                                  class: {
                                    "status-inactive": !props.item.active
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        props.item.active
                                          ? _vm.$tc("Active", 1)
                                          : _vm.$tc("Inactive", 1)
                                      ) +
                                      "\n            "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("div", {
                                  staticClass: "user-status-icon",
                                  class: {
                                    "status-inactive": !props.item.visible
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        props.item.visible
                                          ? _vm.$t("Visible")
                                          : _vm.$t("NotVisible")
                                      ) +
                                      "\n            "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("app-datatable-action-buttons", {
                                    attrs: {
                                      "user-can-edit": _vm.userHasPermissionTo(
                                        "update"
                                      ),
                                      "user-can-delete":
                                        !props.item.blocked &&
                                        _vm.userHasPermissionTo("destroy")
                                    },
                                    on: {
                                      edit: function($event) {
                                        return _vm.editItem(props.item)
                                      },
                                      delete: function($event) {
                                        return _vm.askConfirmationToDeleteItem(
                                          props.item
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      }
                    },
                    {
                      key: "pageText",
                      fn: function(props) {
                        return [
                          _vm._v(
                            "\n        " +
                              _vm._s(props.pageStart) +
                              " - " +
                              _vm._s(props.pageStop) +
                              " " +
                              _vm._s(_vm.$t("tables.Of")) +
                              "\n        " +
                              _vm._s(props.itemsLength) +
                              "\n      "
                          )
                        ]
                      }
                    },
                    {
                      key: "no-results",
                      fn: function() {
                        return [
                          _c("data-table-no-results", {
                            attrs: { search: _vm.searchFromParent }
                          })
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "no-data",
                      fn: function() {
                        return [
                          _vm.loading
                            ? _c("div")
                            : _c(
                                "v-alert",
                                {
                                  staticClass: "data-table-no-data",
                                  attrs: { icon: "warning" }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.$t("NoDataRoles")) +
                                      "\n        "
                                  )
                                ]
                              )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  3970848180
                )
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.canSeeTable ? _c("app-no-permission-warning") : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.deleteDialog,
          title: _vm.$t("DeleteRole"),
          content:
            _vm.$t("DeleteConfirmation") + " " + _vm.itemToDelete.label + "?",
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes"),
          loading: _vm.loadingDelete
        },
        on: { mainAction: _vm.cancelDelete, secondaryAction: _vm.deleteItem }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30d34510", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d34510","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/Accounts/ClientRoles/ClientRoleList.vue
// module id = null
// module chunks = 